const remoteServerUrl = 'https://api.xhorse.net.cn/release/web/mydata'
// const remoteServerUrl = 'http://localhost:8085';
export default remoteServerUrl



//////////////////
// WEBPACK FOOTER
// ./api/config.js
// module id = Db8h
// module chunks = 0